import * as zendesk from './Zendesk/actionTypes'

export const ADD_NOTIF = 'APP/ADD_NOTIF'
export const BOOTSTRAP = 'APP/BOOTSTRAP'
export const GET_COUNTRIES = 'APP/GET_COUNTRIES'
export const GET_LOGIN_MESSAGING = 'APP/GET_LOGIN_MESSAGING'
export const GET_VERIFF_METADATA = 'APP/GET_VERIFF_METADATA'
export const HIDE_MODAL = 'APP/HIDE_MODAL'
export const READY = 'APP/READY'
export const REMOVE_EXPIRED_NOTIF = 'APP/REMOVE_EXPIRED_NOTIF'
export const REMOVE_NOTIF = 'APP/REMOVE_NOTIF'
export const SHOW_MODAL = 'APP/SHOW_MODAL'
export const SET_COUNTRIES = 'APP/SET_COUNTRIES'
export const SET_HEADER_STICKY = 'APP/SET_HEADER_STICKY'
export const SET_MODAL_DISMISSABLE = 'APP/SET_MODAL_DISMISSABLE'
export const SET_MODAL_FULLSCREEN = 'APP/SET_MODAL_FULLSCREEN'
export const SET_MODAL_LARGESCREEN = 'APP/SET_MODAL_LARGESCREEN'
export const SET_SCREEN_SIZE = 'APP/SET_SCREEN_SIZE'
export const SET_US_STATES = 'APP/SET_US_STATES'
export const SET_VERIFF_METADATA = 'APP/SET_VERIFF_METADATA'
export const SET_VERIFF_METADATA_ERROR = 'APP/SET_VERIFF_METADATA_ERROR'
export const SET_LANGUAGE = 'APP/SET_LANGUAGE'
export const TOGGLE_WIDGET_EXPANDED = 'APP/TOGGLE_WIDGET_EXPANDED'

export { zendesk }
